var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClient21(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 264.584,
    height: 22.525,
    viewBox: "0 0 264.584 22.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3557",
    "data-name": "Rectangle 3557",
    width: 264.584,
    height: 22.526,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11128",
    "data-name": "Group 11128",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15922",
    "data-name": "Path 15922",
    d: "M1598.477,6.541c.11.457-.5.232-.846.341-.37.115-1.387.542-1.387.985v9.276h9.768V7.866a2.024,2.024,0,0,0-.649-.746l-1.584-.579h9.35c.11.457-.5.232-.846.341-.579.18-1.28.438-1.379,1.132l.064,18.89a2.816,2.816,0,0,0,1.818.978c.226.062.411-.15.342.28h-9.35c-.066-.408.094-.227.325-.3.377-.113,1.908-.536,1.908-1.029v-9h-9.768v9a3.6,3.6,0,0,0,.738.657l1.494.529h-9.35l1.745-.7a1.563,1.563,0,0,0,.612-1.2c-.279-5.631.426-11.708.022-17.287-.122-1.689-.57-1.655-1.988-2.059-.146-.042-.421-.033-.39-.236Z",
    transform: "translate(-1478.187 -6.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15923",
    "data-name": "Path 15923",
    d: "M3128.359,27.944c.387-.409,1.079-.562,1.525-.915a2.229,2.229,0,0,0,.853-1.937c.4-5.437-.3-11.381-.019-16.872a1.793,1.793,0,0,0-.754-1.2l-1.605-.555,13.332-.007c3.787.333,7.5,1.609,9.346,5.165,1.781,3.422,1.386,8.887-1.052,11.926-5.081,6.336-14.552,3.926-21.627,4.4m7.117-21.062V25.365c0,1.189,3.882,1.955,4.816,2.021,3.958.277,5.981-1.791,6.586-5.549.888-5.518-.313-14.955-7.7-14.955Z",
    transform: "translate(-2909.966 -6.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15924",
    "data-name": "Path 15924",
    d: "M2054.635,7.337c-.467.274-2.8-1.023-3.461-1.089l1.954-1.183c.662-.6.871-1.016.472-1.87-.908-1.94-4.779-1.938-5.715-.023-1.16,2.372,1.2,3.1,2.874,3.84,2.562,1.129,5.348,1.787,7.742,3.26a32.858,32.858,0,0,0,2.65-2.488c.157-.13.226-.338.488-.278.105.106-.322.636-.421.763-.625.8-1.426,1.6-2.087,2.379l0,.2c2.492,1.545,3.558,5.271,2.656,8.029-1.592,4.869-8.426,5.853-11.8,2.3-2.843,2.491-6.855,3.018-9.905.549-5.2-4.207-2.408-13.494,4.445-12.813,3.989.4,5.906,4.716,7.556,7.795l2.854-2.725c.082-.213-.439-.4-.6-.507a54.816,54.816,0,0,1-5.1-2.991c-2.411-1.879-4.353-4.8-2.166-7.715,3.19-4.255,10.538-.222,7.567,4.563m-13.127,3.27c-1.7.293-3.013,2.792-3.172,4.362a7.139,7.139,0,0,0,3.251,6.652c1.852,1.122,3.844.766,5.681-.234.45-.245,1.87-1.142,1.795-1.644-1.2-1.921-1.993-4.156-3.12-6.1-1-1.724-2.165-3.425-4.435-3.032m14.355,3.878-2.884,3.265c-.348.583.492,1.711.869,2.215,1.115,1.494,2.762,2.822,4.656,1.772,3.412-1.892-.614-6-2.641-7.253",
    transform: "translate(-1895.158 -0.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15925",
    "data-name": "Path 15925",
    d: "M598.611,1.528c8.263-.931,14.815,3.7,14.123,12.444-1.069,13.51-24.939,13.671-23.727-2.793.363-4.931,4.764-9.105,9.6-9.651m.137.555c-3.131.427-4.6,4.85-4.717,7.56-.2,4.577,2.167,12.987,7.626,13.591,5.019.555,6.285-5.761,6.062-9.546-.271-4.606-3.189-12.395-8.971-11.606",
    transform: "translate(-547.847 -1.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15926",
    "data-name": "Path 15926",
    d: "M2781.961,1.849c7.527-.8,14.159,3.559,13.852,11.615-.557,14.618-25.028,14.258-23.874-1.685a10.992,10.992,0,0,1,10.022-9.93m-.424.553c-7.295,1.129-5.166,20.633,3.318,21.167,3.489.22,5.249-3.122,5.753-6.1.9-5.305-2.059-16.152-9.072-15.066",
    transform: "translate(-2578.391 -1.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15927",
    "data-name": "Path 15927",
    d: "M13.537,7.412c.931-3.657-2.588-7.045-6.2-6.68A3.622,3.622,0,0,0,5.678,7.384C8,8.839,10.891,8.844,13.309,10.079c5.847,2.987,4.565,10.859-1.726,12.19A14.788,14.788,0,0,1,0,19.545l3.977-4.46a7.461,7.461,0,0,0,1.328,4.669c2.721,3.412,9.656,2.2,8.414-2.97-.546-2.27-4.455-2.749-6.323-3.3C4.615,12.653,1.7,11.137.905,8.11c-2.341-8.926,11.684-10.1,15.96-4.839Z",
    transform: "translate(0 -0.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15928",
    "data-name": "Path 15928",
    d: "M2512.3,7.438V5.276a7.863,7.863,0,0,0-.671-1.7c-1.648-2.891-7.233-4.2-8.749-.6-2.19,5.2,5.816,5.608,8.772,6.995s4.6,3.953,3.935,7.241c-1.474,7.281-12.463,6.229-16.817,2.279l3.764-4.377.34,2.238c.5,5.485,10.3,6.125,9.69.078-.326-3.242-6.215-3.578-8.686-4.708-3.548-1.622-5.9-5.452-3.79-9.189,2.229-3.955,8.842-3.994,12.542-2.349.481.214,3.09,1.689,3.009,2.123Z",
    transform: "translate(-2324.331 -0.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15929",
    "data-name": "Path 15929",
    d: "M1286.967,9.524c1.346-4.5-.232-9.265-5.658-8.793-3.849.335-5.219,4.443-5.366,7.748-.33,7.42,4.993,14.77,12.979,11.439l2.23-1.606a5.465,5.465,0,0,1-2.384,2.568c-3.532,2.185-8.885,1.921-12.45-.085a10.75,10.75,0,0,1-.225-18.723c4.854-2.88,13.1-3.287,16.293,2.222Z",
    transform: "translate(-1182.025 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15930",
    "data-name": "Path 15930",
    d: "M283.788,9.61c-.232.038-.129-.169-.1-.312.386-2.242.889-4.2-.5-6.261a5.5,5.5,0,0,0-9.27.533c-3.175,5.433-.453,16.26,6.616,17.185,3.176.415,4.646-.3,6.962-2.217.115-.1.287-.418.42-.14.059.122-.633,1.025-.773,1.181-3.213,3.584-9.722,3.595-13.765,1.492a10.754,10.754,0,0,1-.14-19.158C278-.652,286.173-1.078,289.032,4.45Z",
    transform: "translate(-248.764 -0.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15931",
    "data-name": "Path 15931",
    d: "M977.26,6.541l-1.675,7.114V11.632c0-.108-.285-1.137-.353-1.321-.995-2.728-3.767-3.145-6.346-3.073v19.32a1.9,1.9,0,0,0,.739.8l2.191.669H961.212l2.423-.856a2.123,2.123,0,0,0,.507-.888V7.238c-4.45-.341-6.6,2.537-8.337,6.11-.092.189.089.385-.315.305l1.535-7.113Z",
    transform: "translate(-888.787 -6.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15932",
    "data-name": "Path 15932",
    d: "M3440.2,24.116l1.681-1.04c3.228-5.6,5.276-11.91,8.02-17.789l.086-.961c.905-.322,1.848-.573,2.727-.971.455-.206,1.477-.951,1.79-1s.165.076.222.2c3.059,6.816,5.166,14.1,8.408,20.817l1.488.744h-10.048l1.864-.578c1.626-1.279.193-3.049-.205-4.566l-11.572.047c-.412,1.183-1.786,3.177-.622,4.26l1.744.838Zm4.745-5.719h9.559c.4,0,1.244-.607,1.022-1.149l-4.693-11.781-.3-.321Z",
    transform: "translate(-3200.032 -2.177)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient21);
export default __webpack_public_path__ + "static/media/client21.1838f64d8033fe547ee7b10d6c52d74b.svg";
export { ForwardRef as ReactComponent };